import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '@/shared/ui';

import { templateEditorMessages } from '../../config';
import { EditorButton } from '../EditorButton';

import { AiInstructionsButton } from './AiInstructionsButton';
import styles from './AiOptionRow.module.scss';

type AiOptionRowProps = {
  displayNumber: string;
  hasInstructions: boolean;
  readOnly?: boolean;
  className?: string;
  onOpenAiInstructions: () => void;
  onDelete: () => void;
};

export const AiOptionRow: FC<AiOptionRowProps> = (props) => {
  const {
    displayNumber,
    hasInstructions,
    readOnly,
    className,
    onOpenAiInstructions,
    onDelete,
  } = props;

  const { formatMessage } = useIntl();

  return (
    <div
      className={cn(styles.row, className)}
      data-component="template-ai-option-row"
    >
      <span className={cn('p4', styles.number)}>{displayNumber}</span>
      <span className={cn('p3', styles.text)}>
        <Icon name="sparkles" size={20} className={styles.textIcon} />
        {formatMessage(templateEditorMessages.aiOptionRowText)}
      </span>
      {hasInstructions || !readOnly ? (
        <AiInstructionsButton
          hasInstructions={hasInstructions}
          readOnly={readOnly}
          className={styles.aiButton}
          onClick={onOpenAiInstructions}
        />
      ) : (
        <span className={styles.iconPlaceholder} />
      )}
      {readOnly ? (
        <span className={styles.iconPlaceholder} />
      ) : (
        <EditorButton
          variant="icon"
          className={styles.deleteButton}
          title={formatMessage(templateEditorMessages.deleteAiOption)}
          onClick={onDelete}
        >
          <Icon name="delete" size={18} />
        </EditorButton>
      )}
    </div>
  );
};
